var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"number-metric"},[_c('Typography',{attrs:{"variant":_vm.valueVariant,"as":"span"}},[_vm._v(_vm._s(_vm.valueText))]),(_vm.resolvedLabel)?_c('Typography',{attrs:{"variant":"body-1","as":"span"}},[_vm._v(_vm._s(_vm.resolvedLabel))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }